export default __webpack_public_path__ + "static/media/bem-2.3c3e455d.svg";